import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@components/ui/sheet"
import { useDrawer } from "@contexts/DrawerContext"

export const AppDrawer = () => {
  const { stack, closeDrawer, removeEntry } = useDrawer()

  return (
    <>
      {stack.map((entry) => (
        <Sheet
          key={entry.id}
          open={entry.open}
          onOpenChange={(isOpen) => {
            if (!isOpen) closeDrawer()
          }}
        >
          <SheetContent
            side="right"
            className="tw:min-w-[50vw] tw:overflow-y-auto tw:shadow-xl"
            onAnimationEnd={() => {
              if (!entry.open) removeEntry(entry.id)
            }}
            aria-describedby={undefined}
          >
            <SheetHeader className="tw:border-b tw:border-gray-300">
              <SheetTitle className="tw:text-center">
                {entry.title || ""}
              </SheetTitle>
            </SheetHeader>

            <div className="tw:p-4">{entry.content}</div>
          </SheetContent>
        </Sheet>
      ))}
    </>
  )
}
